import Text from "../components/Text";
import styles from "./Legal.module.css";

export default function Datenschutz() {
    return (
        <div class={styles.page}>
            <div class={styles.heroBand}>
                <div class={styles.heroInner}>
                    <span class={styles.eyebrow}><Text val="DSE_EYEBROW" /></span>
                    <h1 class={styles.heroTitle}><Text val="DSE_TITLE" /></h1>
                    <p class={styles.heroSubtitle}><Text val="DSE_SUBTITLE" /></p>
                </div>
            </div>

            <main class={styles.content}>
                <section class={styles.section}>
                    <h2><Text val="DSE_CTRL_TITLE" /></h2>
                    <div class={styles.card}>
                        <p>
                            Elias Traunbauer<br />
                            Wasserwerkstraße 2<br />
                            4052 Ansfelden<br />
                            Oberösterreich, Österreich<br />
                            <Text val="DSE_EMAIL_LABEL" />: <a href="mailto:elias.traunbauer@gmx.at">elias.traunbauer@gmx.at</a>
                        </p>
                        <p class={styles.muted}><Text val="DSE_CTRL_NOTE" /></p>
                    </div>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_PURPOSE_TITLE" /></h2>
                    <p><Text val="DSE_PURPOSE_INTRO" /></p>
                    <ul>
                        <li><Text val="DSE_PURPOSE_1" /></li>
                        <li><Text val="DSE_PURPOSE_2" /></li>
                    </ul>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_CATEGORIES_TITLE" /></h2>
                    <ul>
                        <li><strong><Text val="DSE_CAT_ACCOUNT_T" /></strong>: <Text val="DSE_CAT_ACCOUNT_B" /></li>
                        <li><strong><Text val="DSE_CAT_MS_T" /></strong>: <Text val="DSE_CAT_MS_B" /></li>
                        <li><strong><Text val="DSE_CAT_BOT_T" /></strong>: <Text val="DSE_CAT_BOT_B" /></li>
                        <li><strong><Text val="DSE_CAT_LOGS_T" /></strong>: <Text val="DSE_CAT_LOGS_B" /></li>
                        <li><strong><Text val="DSE_CAT_TECH_T" /></strong>: <Text val="DSE_CAT_TECH_B" /></li>
                    </ul>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_OAUTH_TITLE" /></h2>
                    <p><Text val="DSE_OAUTH_INTRO" /></p>
                    <ul>
                        <li><Text val="DSE_OAUTH_XBOX" /></li>
                        <li><Text val="DSE_OAUTH_OFFLINE" /></li>
                    </ul>
                    <p><Text val="DSE_OAUTH_NEVER" /></p>
                    <p><Text val="DSE_OAUTH_STORAGE" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_HOSTING_TITLE" /></h2>
                    <p><Text val="DSE_HOSTING_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_THIRDPARTY_TITLE" /></h2>
                    <p><Text val="DSE_THIRDPARTY_MS" /></p>
                    <p><Text val="DSE_THIRDPARTY_MCSERVER" /></p>
                    <p><Text val="DSE_THIRDPARTY_PROXIES_INTRO" /></p>
                    <ul>
                        <li><strong>Hetzner Online GmbH</strong> (Deutschland) - <Text val="DSE_THIRDPARTY_EU" /></li>
                        <li><strong>netcup GmbH</strong> (Deutschland) - <Text val="DSE_THIRDPARTY_EU" /></li>
                        <li><strong>Oracle Cloud Infrastructure</strong> (Region Frankfurt, Oracle Corporation, USA) - <Text val="DSE_THIRDPARTY_US" /></li>
                        <li><strong>Webshare Software Inc.</strong> (USA, Proxy-Server in Deutschland) - <Text val="DSE_THIRDPARTY_US" /></li>
                    </ul>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_COOKIES_TITLE" /></h2>
                    <p><Text val="DSE_COOKIES_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_RETENTION_TITLE" /></h2>
                    <p><Text val="DSE_RETENTION_INTRO" /></p>
                    <div class={styles.tableWrap}>
                        <table class={styles.table}>
                            <thead>
                                <tr>
                                    <th><Text val="DSE_RET_COL_DATA" /></th>
                                    <th><Text val="DSE_RET_COL_TIME" /></th>
                                    <th><Text val="DSE_RET_COL_BASIS" /></th>
                                    <th><Text val="DSE_RET_COL_DELETE" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td><Text val="DSE_RET_R1_DATA" /></td><td><Text val="DSE_RET_R1_TIME" /></td><td>Art. 6 Abs. 1 lit. b DSGVO</td><td>Art. 5 Abs. 1 lit. e DSGVO</td></tr>
                                <tr><td><Text val="DSE_RET_R2_DATA" /></td><td><Text val="DSE_RET_R2_TIME" /></td><td>Art. 6 Abs. 1 lit. b DSGVO</td><td>Art. 5 Abs. 1 lit. e DSGVO</td></tr>
                                <tr><td><Text val="DSE_RET_R3_DATA" /></td><td><Text val="DSE_RET_R3_TIME" /></td><td>Art. 6 Abs. 1 lit. b DSGVO</td><td>Art. 5 Abs. 1 lit. e DSGVO</td></tr>
                                <tr><td><Text val="DSE_RET_R4_DATA" /></td><td><Text val="DSE_RET_R4_TIME" /></td><td>Art. 6 Abs. 1 lit. f DSGVO</td><td>Art. 5 Abs. 1 lit. e DSGVO</td></tr>
                                <tr><td><Text val="DSE_RET_R5_DATA" /></td><td><Text val="DSE_RET_R5_TIME" /></td><td>Art. 6 Abs. 1 lit. f DSGVO</td><td>Art. 5 Abs. 1 lit. e DSGVO</td></tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_RIGHTS_TITLE" /></h2>
                    <p><Text val="DSE_RIGHTS_INTRO" /></p>
                    <ul>
                        <li><strong>Art. 15</strong>: <Text val="DSE_R_15" /></li>
                        <li><strong>Art. 16</strong>: <Text val="DSE_R_16" /></li>
                        <li><strong>Art. 17</strong>: <Text val="DSE_R_17" /></li>
                        <li><strong>Art. 18</strong>: <Text val="DSE_R_18" /></li>
                        <li><strong>Art. 20</strong>: <Text val="DSE_R_20" /></li>
                        <li><strong>Art. 21</strong>: <Text val="DSE_R_21" /></li>
                    </ul>
                    <p><Text val="DSE_RIGHTS_HOW" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_AUTHORITY_TITLE" /></h2>
                    <p><Text val="DSE_AUTHORITY_BODY" /></p>
                    <div class={styles.card}>
                        <p>
                            Österreichische Datenschutzbehörde<br />
                            Barichgasse 40-42<br />
                            1030 Wien, Österreich<br />
                            <a href="https://www.dsb.gv.at" target="_blank" rel="noopener">www.dsb.gv.at</a>
                        </p>
                    </div>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_MINORS_TITLE" /></h2>
                    <p><Text val="DSE_MINORS_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_AUTOMATED_TITLE" /></h2>
                    <p><Text val="DSE_AUTOMATED_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_SECURITY_TITLE" /></h2>
                    <p>
                        <Text val="DSE_SECURITY_BODY" /> <a href="/security"><Text val="DSE_SECURITY_LINK" /></a>
                    </p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="DSE_CHANGES_TITLE" /></h2>
                    <p><Text val="DSE_CHANGES_BODY" /></p>
                    <p class={styles.muted}><Text val="DSE_LAST_UPDATED" />: 12.05.2026</p>
                </section>
            </main>
        </div>
    );
}
